import { AppInfo } from '@/components/appInfo/appInfo.comp';
import { Banner } from '@/components/banner/banner.comp';
import { CategoriesCatalog } from '@/components/categoriesCatalog/categoriesCatalog.comp';
import { Layout } from '@/components/layout/layout.comp';
import { MoreApps } from '@/components/moreApps/moreApps.comp';
import { Platforms } from '@/components/platforms/platforms.comp';
import { WidgetCatalog } from '@/components/widgetCatalog/widgetCatalog.comp';
import { appSynonymGlobal } from '@/globals/appSynonym.global';
import { getDataFromDB } from '@/lib/mongodb';
import { getRandomApps } from '@/lib/search';
import { getSearchEngineDataDB } from '@/lib/searchEngineMongodb';
import { IPlatform, IPlugin, THit } from '@/types';
// import fs from 'fs';
import Script from 'next/script';

export default function AppPage({
	appSlug,
	apps,
	app,
	platform,
	categories,
	moreApps,
}: {
	appSlug: string;
	apps: IPlugin[];
	app: THit;
	platform: IPlatform;
	categories: { displayName: string; slug: string }[];
	moreApps: THit[];
}) {
	return (
		<Layout
			showFooter={true}
			showHeader={true}
			title={`${(app?.name || '').replace(/\&#x2011;/g, '- ')} for ${
				platform.displayName
			}`}
		>
			{loadScripts(app, platform)}
			<AppInfo
				appSlug={appSlug}
				promoApp={apps[0]}
				app={app}
				platform={platform}
			/>
			<CategoriesCatalog platform={platform} categories={categories} />
			<WidgetCatalog apps={apps} platform={platform} />
			<MoreApps
				appSynonym={(appSynonymGlobal as any)[platform.name || ''] || 'app'}
				hits={moreApps}
			/>
			<Platforms />
			<Banner />
		</Layout>
	);
}

export async function getServerSideProps(context: any) {
	const { app, platform } = context.query || {};

	try {
		const filteredApps = await getSearchEngineDataDB<IPlugin>('platformapps', {
			slug: app,
			platform,
			isDeleted: false,
		});

		const platforms = await getSearchEngineDataDB<IPlatform>('platforms', {
			name: platform,
		});
		const categories = await getSearchEngineDataDB('seocategories', {
			platform: platform,
		});

		const apps = await getDataFromDB<IPlugin>('apps', {
			status: 'published',
		});

		const randomApps = apps.sort(() => 0.5 - Math.random()).splice(0, 12);

		if (!filteredApps[0] || !platforms[0]) {
			throw new Error();
		}

		const tags: string[] = (filteredApps[0] as any).tags || [];
		const randomTag = tags.length
			? tags[Math.floor(Math.random() * tags.length)]
			: undefined;
		let moreApps = await getRandomApps({
			platform,
			tag: randomTag,
			limit: 10,
		});
		if (!moreApps.length) {
			moreApps = await getRandomApps({ platform, limit: 10 });
		}

		return {
			props: {
				appSlug: app,
				apps: randomApps,
				app: filteredApps[0],
				platform: platforms[0],
				categories,
				moreApps,
			},
		};
	} catch (e) {
		return {
			notFound: true,
		};
	}
}

// async function getAllPlatformApps(
// 	limit: number = 1000,
// 	page: number = 0,
// 	allApps: any[] = []
// ): Promise<any> {
// 	try {
// 		const apps = await getSearchEngineDataDB<any>(
// 			'platformapps',
// 			{
// 				isDeleted: false,
// 			},
// 			{
// 				platform: 1,
// 				slug: 1,
// 			},
// 			{
// 				limit,
// 				skip: page * limit,
// 			}
// 		);

// 		// const filePath: string = `./platform-apps.json`;
// 		// let allApps: any[] = [];

// 		// if (fs.existsSync(filePath)) {
// 		// 	const rawdata = fs.readFileSync(filePath) as any;
// 		// 	allApps = JSON.parse(rawdata);
// 		// }

// 		// console.log('allApps', allApps.length);

// 		if (!apps.length) {
// 			return allApps;
// 		}

// 		allApps = [...allApps, ...apps];

// 		// fs.writeFileSync(filePath, JSON.stringify([...allApps, ...apps]));

// 		return await getAllPlatformApps(limit, page + 1, allApps);
// 	} catch (e) {
// 		console.error('getAllPlatformApps', e);
// 	}
// }

// export async function getStaticPaths() {
// 	try {
// 		const platforms = await getSearchEngineDataDB<any>(
// 			'platforms',
// 			{},
// 			{
// 				appSynonym: 1,
// 				name: 1,
// 			}
// 		);

// 		const platformsSynonymMap: any = {};
// 		platforms.forEach((platform) => {
// 			platformsSynonymMap[platform.name] = platform.appSynonym;
// 		});

// 		const platformApps: any[] = await getAllPlatformApps();

// 		const paths = platformApps.map((app) => {
// 			return {
// 				params: {
// 					app: app.slug,
// 					synonym: platformsSynonymMap[app.platform] || 'app',
// 					platform: app.platform,
// 				},
// 			};
// 		});
// 		return { paths, fallback: false };
// 	} catch (e) {
// 		console.error(e);
// 		return { paths: [], fallback: false };
// 	}
// }

// export async function getStaticProps({
// 	params,
// }: GetStaticPropsContext<{
// 	app?: string;
// 	synonym?: string;
// 	platform?: string;
// }>) {
// 	const { app, synonym, platform } = params || {};

// 	try {
// 		const filteredApps = await getSearchEngineDataDB<IPlugin>('platformapps', {
// 			slug: app,
// 			platform,
// 		});

// 		const platforms = await getSearchEngineDataDB<IPlatform>('platforms', {
// 			name: platform,
// 		});
// 		const categories = await getSearchEngineDataDB('seocategories', {
// 			platform: platform,
// 		});

// 		const apps = await getDataFromDB<IPlugin>('apps', {
// 			status: 'published',
// 		});
// 		const randomApps = apps.sort(() => 0.5 - Math.random()).splice(0, 12);

// 		if (!filteredApps[0] || !platforms[0]) {
// 			throw new Error();
// 		}

// 		return {
// 			props: {
// 				appSlug: app,
// 				apps: randomApps,
// 				app: filteredApps[0],
// 				platform: platforms[0],
// 				categories,
// 			},
// 		};
// 	} catch (e) {
// 		return {
// 			notFound: true,
// 		};
// 	}
// }

function loadScripts(app: THit, platform: IPlatform) {
	const shortDescription =
		`${(app?.name || '').replace(/\&#x2011;/g, '- ') || ''} - ${app.teaser}` ||
		`Learn more about ${
			(app?.name || '').replace(/\&#x2011;/g, '- ') || ''
		} for ${platform.displayName}`;
	let ratingValue = app.rating || 5;
	if (ratingValue > 5) {
		ratingValue = 5;
	}
	if (ratingValue < 1) {
		ratingValue = 1;
	}
	return (
		<>
			{app.numberOfReviews > 0 && (
				<Script id="app-script-1" type="application/ld+json">{`
          {
            "@context": "https://schema.org/", 
            "@type": "Product", 
            "name": "${(app?.name || '').replace(/\&#x2011;/g, '- ') || ''}",
            "image": "${app.icon}",
            "description": "${shortDescription.replace(/"/g, `'`)}",
            "brand": "${app.developer?.name || 'Unknown'}",
            "aggregateRating": {
              "@type": "AggregateRating",
              "worstRating": "1",
              "bestRating": "5",
              "ratingValue": "${ratingValue}",
              "ratingCount": "${app.numberOfReviews || 1}"
            }
          }
        `}</Script>
			)}
			<Script id="app-script-2" type="application/ld+json">{`
        {
          "@context": "https://schema.org/", 
          "@type": "BreadcrumbList", 
          "itemListElement": [{
            "@type": "ListItem", 
            "position": 1, 
            "name": "Discover",
            "item": "https://discover.commoninja.com/"  
          },{
            "@type": "ListItem", 
            "position": 2, 
            "name": "${platform.displayName}",
            "item": "https://discover.commoninja.com/${platform.name || ''}"  
          },{
            "@type": "ListItem", 
            "position": 3, 
            "name": "${(app?.name || '').replace(/\&#x2011;/g, '- ') || ''}",
            "item": "https://discover.commoninja.com/${platform.name || ''}/${
				(appSynonymGlobal as any)[platform.name || ''] || 'app'
			}/${app.slug}"  
          }]
        }
        `}</Script>
		</>
	);
}
